.status {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
